import {CALL_TRACKING_SERVICES, DEFAULT_CULTURE, ORDER, SORT_FIELDS} from '../base.js'
import {
  BODY_TYPE_ID_MOPED,
  BODY_TYPE_ID_MOPED_2,
  BODY_TYPE_ID_MOPED_GEARS,
  BODY_TYPE_ID_OFFROAD,
  BODY_TYPE_ID_OFFROAD_CROSS,
  BODY_TYPE_ID_OFFROAD_ENDURO,
  BODY_TYPE_ID_OFFROAD_KIDS,
  BODY_TYPE_ID_OFFROAD_TRAIL,
  BODY_TYPE_ID_OFFROAD_TRIAL,
  BODY_TYPE_ID_ROAD,
  BODY_TYPE_ID_ROAD_CUSTOM,
  BODY_TYPE_ID_ROAD_NAKED,
  BODY_TYPE_ID_ROAD_SPORT,
  BODY_TYPE_ID_ROAD_SUPERMOTARD,
  BODY_TYPE_ID_ROAD_TOURISM,
  BODY_TYPE_ID_SCOOTER,
  BODY_TYPE_ID_SCOOTER_50,
  BODY_TYPE_ID_SCOOTER_125,
  BODY_TYPE_ID_SCOOTER_125PLUS,
  BUGGIES_CATEGORY1_ID,
  CATEGORY2_ID_MOTO_CLOTHING,
  CATEGORY2_ID_MOTO_PARTS,
  CATEGORY2_ID_MOTORCYCLE,
  CATEGORY2_ID_OFFROAD,
  CATEGORY2_ID_ROAD,
  CATEGORY2_ID_SCOOTER,
  CATEGORY2_ID_TRUNK,
  CATEGORY2_ID_WHEELS,
  CLASSICS_CATEGORY1_ID,
  FUEL_TYPE_ELECTRIC_ID,
  FUEL_TYPE_GASOLINE_ID,
  MINIMOTOS_CATEGORY1_ID,
  MOTOS_CATEGORY1_ID,
  OFFER_TYPE_NEW,
  OFFER_TYPE_SECOND_HAND,
  QUADS_CATEGORY1_ID,
  RECOMMENDATIONS_TARGETS
} from './ads.js'
import {C2B_ORIGINS} from './c2b.js'
import {SELLER_TYPE_PRIVATE, SELLER_TYPE_PROFESSIONAL} from './dealer.js'
import {
  ADS_LIST_BUGGIES_NEW_PAGE_NAME,
  ADS_LIST_BUGGIES_PAGE_NAME,
  ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
  ADS_LIST_MINIMOTOS_NEW_PAGE_NAME,
  ADS_LIST_MINIMOTOS_PAGE_NAME,
  ADS_LIST_NEW_PAGE_NAME,
  ADS_LIST_PAGE_NAME,
  ADS_LIST_QUADS_NEW_PAGE_NAME,
  ADS_LIST_QUADS_PAGE_NAME,
  HOME_PAGE_NAME
} from './page.js'
import {BENEFITS_CARDS_TABS} from './seller.js'
import {USER_CONSENTS} from './user.js'

export const XITI_IS_ENABLED = false
export const IS_BRAZE_ENABLED = true

export const ADS_NAME_PAGE_HOME = 'motosnet/home'
export const ADS_NAME_PAGE_NEWS = 'motosnet/noticias/home'
export const ADS_NAME_PAGE_NEWS_DETAIL = 'motosnet/noticias/ficha'
export const ADS_NAME_PAGE_ADS_LIST = 'motosnet/ocasion/home'
export const ADS_NAME_PAGE_NEWS_CATEGORY = 'motosnet/noticias/home'
export const ADS_NAME_PAGE_NEWS_TAG = 'motosnet/noticias/home'
export const ADS_NAME_PAGE_NEWS_SEARCH = 'motosnet/noticias/home'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS = 'motosnet/fichastecnicas/home'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_HOME = 'motosnet/fichastecnicas/home'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_COMPARATOR = 'motosnet/fichastecnicas/comparativa'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_COMPARATOR_RESULTS = 'motosnet/fichastecnicas/comparativa'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_MAKE = 'motosnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_MODEL = 'motosnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_VERSION = 'motosnet/fichastecnicas/ficha'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_VEHICLE = 'motosnet/fichastecnicas/ficha'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION = 'motosnet/fichastecnicas/ficha'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_SEARCH = 'motosnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_TECHNICAL_DETAILS_SEARCH_RESULTS = 'motosnet/fichastecnicas/listado'
export const ADS_NAME_PAGE_ADS_DETAIL = 'motosnet/ocasion/ficha'

export const PAGE_VIEW_EVENT = 'Page Viewed'
export const LIST_VIEW_EVENT = 'List Viewed'
export const LIST_TRIGGERED_EVENT = 'Lead Triggered'
export const INSURANCES_VIEW_EVENT = 'Insurances Viewed'
export const LIST_FILTERS_VIEW_EVENT = 'Filters Viewed'
export const FILTER_EVENT_NAME = 'ad_filter'

export const AD_IMPRESSIONS_COLLECTED_EVENT = 'Ad Impressions Collected'
export const MODEL_DETAIL_HOME_CLICKED_EVENT = 'Model Detail Home Clicked'
export const MODEL_DETAIL_HOME_SEARCH_CLICKED_EVENT = 'Model Detail Home Search Clicked'
export const SUBSCRIPTION_CAROUSEL_CLICKED_EVENT = 'Listing Four Cards Carousel Clicked'

export const EVENT_NAME = 'other'
export const HOME_EVENT_NAME = 'homepage'
export const LOGIN_NAME_PAGE_NEWS = ''
export const LOGIN_EVENT_NAME = 'login'
export const NEWS_CATEGORY_EVENT_NAME = 'editorial_news'
export const NEWS_TAG_EVENT_NAME = 'editorial_search'
export const NEWS_SEARCH_EVENT_NAME = 'editorial_search'
export const USER_FAVORITE_ADS_EVENT_NAME = 'my_saved_ads'
export const TERMS_OF_SERVICE_EVENT_NAME = 'other'
export const TERMS_OF_SERVICE_ADS_NAME_PAGE = ''
export const CHECKOUT_EVENT_NAME = 'checkout'
export const CHECKOUT_SUCCESS_EVENT_NAME = 'checkout_success'
export const CHECKOUT_ERROR_EVENT_NAME = 'checkout_error'
export const CHECKOUT_PENDING_EVENT_NAME = 'checkout_pending'
export const CHECKOUT_ACTIVATION_ERROR_EVENT_NAME = 'checkout_activation_error'
export const CHECKOUT_REFUND_ERROR_EVENT_NAME = 'checkout_refund_error'
export const CHECKOUT_REQUEST_ERROR_EVENT_NAME = 'checkout_request_error'
export const CHECKOUT_UNKNOWN_ERROR_EVENT_NAME = 'checkout_unknown_error'
export const PAYMENT_AD_REQUEST_EVENT_NAME = 'pay_ad'
export const PRODUCTS_EVENT_NAME = 'bump_webpage'
export const TECHNICAL_DETAILS_EVENT_NAME = 'technical_details'
export const TECHNICAL_DETAILS_HOME_EVENT_NAME = 'technical_details'
export const TECHNICAL_DETAILS_COMPARATOR_EVENT_NAME = 'technicaldetails_comparemotos'
export const TECHNICAL_DETAILS_COMPARATOR_RESULTS_EVENT_NAME = 'comparison_result'
export const TECHNICAL_DETAILS_MAKE_EVENT_NAME = 'technicaldetails_brand'
export const TECHNICAL_DETAILS_MODEL_EVENT_NAME = 'technicaldetails_model'
export const TECHNICAL_DETAILS_BODY_TYPE_EVENT_NAME = 'technicaldetails_brand_listing'
export const TECHNICAL_DETAILS_VERSION_EVENT_NAME = 'technicaldetails_version'
export const TECHNICAL_DETAILS_VEHICLE_EVENT_NAME = 'technicaldetails_vehicle'
export const TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_EVENT_NAME = 'technicaldetails_vehicle'
export const TECHNICAL_DETAILS_SEARCH_EVENT_NAME = 'technicaldetails_adv_search'
export const TECHNICAL_DETAILS_SEARCH_RESULTS_EVENT_NAME = 'technicaldetails_adv_search'
export const ADS_LIST_MAKE_EVENT_NAME = 'list'
export const ADS_DETAIL_EVENT_NAME = 'detail'

export const CRITEO_ACCOUNT_ID = 25136
export const TRACKING_EVENTS_THAT_NEED_IDENTIFY = []
export const SEARCH_FILTERS_AS_STRING_TYPES = [
  'kmMax',
  'kmMin',
  'powerMin',
  'powerMax',
  'priceMax',
  'priceMin',
  'doors'
]
export const TRACKING_DATA_BY_SITE = {
  vertical: 'motor',
  site: 'motos.coches.net',
  platform: 'web'
}
export const COMMON_ADS_LIST = {
  channel: 'ads',
  page_type: 'list',
  event: LIST_VIEW_EVENT
}

// According to Messaging tracking documentation
// https://docs.mpi-internal.com/tnt-messaging/messaging-fe-widget/docs/docs/features/tracking/
export const MESSAGING_AD_VIEW_EVENT = 'Ad View'
export const MESSAGING_BLOCK_USER_CHAT_EVENT = 'Block user chat'
export const MESSAGING_BLOCK_USER_INBOX_EVENT = 'Block user inbox'
export const MESSAGING_CHAT_VIEW_EVENT = 'Chat view'
export const MESSAGING_DELETION_CHAT_EVENT = 'Conversation deletion chat'
export const MESSAGING_DELETION_INBOX_EVENT = 'Conversation deletion inbox'
export const MESSAGING_SEND_EVENT = 'Message sent'
export const MESSAGING_SEND_BUTTON_CLICKED_EVENT = 'SEND_BUTTON_CLICKED'

const AD_COMPLAINT_EVENT_NAMES = {
  AD_REPORTED: 'Ad Reported',
  AD_REPORTED_ERROR: 'Ad Reported Error',
  REPORT_AD_VIEWED: 'Report Ad Viewed'
}

export const MESSAGING_EVENT_NAMES = {
  [MESSAGING_AD_VIEW_EVENT]: 'My Messaging Ad Clicked',
  [MESSAGING_BLOCK_USER_CHAT_EVENT]: 'My Messaging User Blocked',
  [MESSAGING_BLOCK_USER_INBOX_EVENT]: 'My Messaging User Blocked',
  [MESSAGING_CHAT_VIEW_EVENT]: 'My Messaging Inbox Conversation Opened',
  [MESSAGING_DELETION_CHAT_EVENT]: 'My Messaging Conversation Deleted',
  [MESSAGING_DELETION_INBOX_EVENT]: 'My Messaging Conversation Deleted',
  [MESSAGING_SEND_EVENT]: 'Message Sent',
  [MESSAGING_SEND_BUTTON_CLICKED_EVENT]: 'Message Sent Clicked'
}

export const AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED_VARIANTS = {
  DOCUMENTATION: 'ver documentacion IO',
  FAQS: 'preguntas frecuentes IO'
}

export const AD_INSERTION_IO_FAQ_EXPANDED_VARIANTS = {
  CAN_I_MODIFY_THE_APPOINTMENT: 'puedo modificar cita',
  HAVE_I_A_COMMITMENT: 'compromisos',
  IS_IT_FREE: 'servicio gratuito',
  WHEN_I_GET_PAID: 'cuando recibire pago'
}

const AD_INSERTION_TRACKING_NAMES = {
  AD_INSERTION_IO_ADD_TO_CALENDAR: 'Ad Insertion IO Add To Calendar',
  AD_INSERTION_IO_BUTTON_CLICKED: 'Ad Insertion IO Button Clicked',
  AD_INSERTION_IO_CAR_DETAILS_ERROR: 'Ad Insertion IO Car Details Error',
  AD_INSERTION_IO_CAR_DETAILS_SUCCESS: 'Ad Insertion IO Car Details Success',
  AD_INSERTION_IO_CAR_DETAILS_VIEWED: 'Ad Insertion IO Car Details Viewed',
  AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED: 'Ad Insertion IO Confirmation Faq Expanded',
  AD_INSERTION_IO_CONFIRMATION_VIEWED: 'Ad Insertion IO Confirmation Viewed',
  AD_INSERTION_IO_DATE_CONFIRMED: 'Ad Insertion IO Date Confirmed',
  AD_INSERTION_IO_DATE_ERROR: 'Ad Insertion IO Date Error',
  AD_INSERTION_IO_DATES_VIEWED: 'Ad Insertion IO Dates Viewed',
  AD_INSERTION_IO_DEALER_ORDER_SELECTED: 'Ad Insertion IO Dealer Order Selected',
  AD_INSERTION_IO_DEALER_SELECTED: 'Ad Insertion IO Dealer Selected',
  AD_INSERTION_IO_DEALERS_VIEWED: 'Ad Insertion IO Dealers Viewed',
  AD_INSERTION_IO_FAQ_EXPANDED: 'Ad Insertion IO Faq Expanded',
  AD_INSERTION_IO_GO_TO_MY_ADS_CLICKED: 'Ad Insertion IO Go To My Ads Clicked',
  AD_INSERTION_IO_MAP_CLICKED: 'Ad Insertion IO Map Clicked',
  AD_INSERTION_IO_MODAL_VIEWED: 'Ad Insertion IO Modal Viewed',
  AD_INSERTION_IO_NO_INTERESA_BUTTON_CLICKED: 'Ad Insertion IO No Interesa Button Clicked',
  AD_INSERTION_IO_NO_OFFER_AVAILABLE: 'Ad Insertion IO No Offer Available',
  AD_INSERTION_IO_POSTAL_CODE_CHANGED: 'Ad Insertion IO Postal Code Changed',
  AD_INSERTION_IO_PUBLISH_AD_CLICKED: 'Ad Insertion IO Publish Ad Clicked',
  AD_INSERTION_IO_VIDEO_PLAYED: 'Ad Insertion IO Video Played',
  AD_INSERTION_IO_WHATSAPP_ACTION: 'Ad Insertion IO Whatsapp Action',
  AD_INSERTION_MODAL_DISMISSED: 'Ad Insertion Modal Dismissed',
  AD_INSERTION_MODAL_VIEWED: 'Ad Insertion Modal Viewed'
}

const INSTANT_OFFER_TRACKING_NAMES = {
  INSTANT_OFFER_FIELD_SELECTED: 'Instant Offer Field Selected',
  INSTANT_OFFER_MODAL_VIEWED: 'Instant Offer Modal Viewed'
}

const SELLER_SELECTOR_TRACKING_EVENT_NAMES = {
  ACCESS_TO_AD_INSERTION_CLICKED: 'Access To Ad Insertion Clicked',
  ACCESS_TO_EDITORIAL_CLICKED: 'Access To Editorial Clicked',
  ACCESS_TO_INSTANT_OFFER_CLICKED: 'Access To Instant Offer Clicked',
  ACCESS_TO_TASADOR_CLICKED: 'Access To Tasador Clicked',
  BENEFITS_OF_SELLING_TO_PRIVATE_CLICKED: 'Seller Selector To Private Clicked',
  BENEFITS_OF_SELLING_TO_PROFESSIONAL_CLICKED: 'Seller Selector To Professional Clicked',
  ACCESS_TO_PROFESIONAL_LANDING_CLICKED: 'Access To Professional Landing Clicked'
}

export const SELLER_SELECTOR_BENEFITS_TABS_TRACKING_EVENT_NAMES = {
  [BENEFITS_CARDS_TABS.BENEFITS_OF_SELLING_TO_PRIVATE]:
    SELLER_SELECTOR_TRACKING_EVENT_NAMES.BENEFITS_OF_SELLING_TO_PRIVATE_CLICKED,
  [BENEFITS_CARDS_TABS.BENEFITS_OF_SELLING_TO_PROFESSIONAL]:
    SELLER_SELECTOR_TRACKING_EVENT_NAMES.BENEFITS_OF_SELLING_TO_PROFESSIONAL_CLICKED
}

export const USER_CONSENTS_TRACKING_EVENT_NAMES = {
  USER_CONSENT_FINANCIAL_SERVICES_CLICKED: 'Financial Services User Consent Clicked',
  USER_CONSENT_WHATSAPP_COMMUNICATIONS_CLICKED: 'Whatsapp Communications User Consent Clicked',
  USER_CONSENT_PORTAL_ANNOUNCEMENTS_CLICKED: 'Portal Announcements User Consent Clicked',
  USER_CONSENT_EXTERNAL_SERVICES_OFFERS_CLICKED: 'External Services Offers User Consent Clicked',
  USER_CONSENT_SEGMENTED_ADS_CLICKED: 'Segmented Ads User Consent Clicked'
}

export const USER_CONSENTS_TRACKING_EVENT_NAMES_MAPPING = {
  [USER_CONSENTS.FINANCIAL_SERVICES]: USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_FINANCIAL_SERVICES_CLICKED,
  [USER_CONSENTS.WHATSAPP_COMMUNICATIONS_C2B]:
    USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_WHATSAPP_COMMUNICATIONS_CLICKED,
  [USER_CONSENTS.PORTAL_ANNOUNCEMENTS]: USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_PORTAL_ANNOUNCEMENTS_CLICKED,
  [USER_CONSENTS.EXTERNAL_SERVICES_OFFERS]:
    USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_EXTERNAL_SERVICES_OFFERS_CLICKED,
  [USER_CONSENTS.SEGMENTED_ADS]: USER_CONSENTS_TRACKING_EVENT_NAMES.USER_CONSENT_SEGMENTED_ADS_CLICKED
}

const LANDING_INSTANT_OFFER_TRACKING_NAMES = {
  LANDING_IO_DATE_CONFIRMED: 'Landing IO Date Confirmed',
  LANDING_IO_FIELD_AUTOCOMPLETED: 'Landing IO Field Autocompleted',
  LANDING_IO_FIELD_SELECTED: 'Landing IO Field Selected',
  LANDING_IO_FORM_FIELDS_ERROR: 'Landing IO Form Fields Error',
  LANDING_IO_NEXT_CONFIRMED: 'Landing IO Next Confirmed',
  LANDING_IO_NEXT_ERROR: 'Landing IO Next Error',
  LANDING_IO_NEXT_VIEWED: 'Landing IO Form Page 2 Viewed',
  LANDING_IO_OFFER_REQUESTED_ERROR: 'Landing IO Offer Requested Error',
  LANDING_IO_OFFER_REQUESTED: 'Landing IO Offer Requested'
}

const VISIBILITY_PRODUCTS_TRACKING_NAMES = {
  VISIBILITY_PRODUCTS_BUTTON_CLICKED: 'Visibility Products Button Clicked'
}

const FAVORITES_TRACKING_NAMES = {
  FAVORITES_VEHICLES_TAB_CLICKED: 'Favorite Vehicles Tab Clicked',
  FAVORITES_DEALER_TAB_CLICKED: 'Favorite Dealers Tab Clicked',
  DEALER_FAVORITED: 'Dealer Favorited',
  DEALER_UNFAVORITED: 'Dealer Unfavorited',
  FAVORITES_DEALER_CARD_CLICKED: 'Dealer Stock Clicked'
}

const NET_ASSISTANT_TRACKING_NAMES = {
  NET_ASSISTANT_CLOSED: 'Net Closed',
  NET_ASSISTANT_WELCOME_CTA_CLICKED: 'Net Predefined Question Clicked',
  NET_ASSISTANT_MICROPHONE_CLICKED: 'Net Microphone Clicked',
  NET_ASSISTANT_MESSAGE_SENT: 'Net Message Sent',
  NET_ASSISTANT_NEW_CHAT_CLICKED: 'Net New Conversation Clicked',
  NET_ASSISTANT_ACCESS_CLICKED: 'Net Access Clicked',
  NET_ASSISTANT_ANSWER_CLICKED: 'Net Answer Clicked',
  NET_ASSISTANT_REVIEW_SENT: 'Net Review Sent',
  NET_ASSISTANT_REVIEW_DETAIL_SENT: 'Net Review Detail Sent',
  NET_ASSISTANT_END_CONVERSTAION_VIEWED: 'Net End Conversation Viewed',
  NET_ASSISTANT_RETRY_VIEWED: 'Net Retry Viewed',
  NET_ASSISTANT_RETRY_CLICKED: 'Net Retry Clicked',
  NET_MENU_CLICKED: 'Net Menu Clicked',
  NET_FULL_SCREEN_CLICKED: 'Net Full Width Clicked',
  NET_FULL_SCREEN_EXIT_CLICKED: 'Net Full Width Exit Clicked',
  NET_ACCESS_HOME_CLICKED: 'Net Access Home Clicked'
}

export const TRACKING_EVENT_NAMES = {
  ACCOUNT_DELETE_CLICKED: 'Privacy Configuration Delete My Data Clicked',
  ACCOUNT_MANAGE_DATA_CLICKED: 'Privacy Configuration How We Manage Your Data Clicked',
  ACCOUNT_TAKEOUT_CLICKED: 'Privacy Configuration Download My Data Clicked',
  ACCOUNT_EDITED: 'Account Edited',
  ACCOUNT_EDITED_ERROR: 'Account Edited Error',
  AD_DETAIL_BUTTON_CLICKED: 'Detail Button Clicked',
  AD_DISCARDED: 'Ad Discarded',
  AD_DISCARDED_CLICK: 'Ad Discarded Clicked',
  AD_FAVORITED: 'Ad Favorited',
  AD_IMPRESSIONS_COLLECTED_EVENT: 'Ad Impressions Collected',
  AD_SHARE_DECLINE: 'Ad Shared Declined',
  AD_SHARE_MODAL_CLOSED: 'Ad Shared Modal Closed',
  AD_SHARE_MODAL_REJECT: 'Ad Shared Pop Up Rejected',
  AD_SHARED: 'Ad Shared',
  AD_SHARED_CLICKED: 'Ad Shared Clicked',
  AD_SUBSCRIPTION_PRICE_OPTION_CLICKED: 'Subscription Ad Price Option Clicked',
  AD_TO_COMPARE_ADDED: 'Comparator Vehicle Added',
  AD_TO_COMPARE_REMOVED: 'Comparator Vehicle Removed',
  AD_TO_COMPARE_MENU_CLICKED: 'Comparator Menu Clicked',
  AD_TO_COMPARE_SEE_RESULTS_CLICKED: 'Show Comparison Clicked',
  AD_UNFAVORITED: 'Ad Unfavorited',
  AI_SEARCH_USED: 'Ai Search Used',
  ALERT_CREATED: 'Alert Created',
  APP_DOWNLOAD_BUTTON_CLICKED: 'App Download Button Clicked',
  APP_SUGGESTION_DRAWER_CLICKED: 'Smartbanner Clicked',
  APP_SUGGESTION_DRAWER_VIEWED: 'Smartbanner Viewed',
  BUTTON_CLICKED: 'Button Clicked',
  DEALER_SERVICES_POPUP: 'Dealer Services Popup',
  DEALER_STOCK_CLICKED: 'Dealer Stock Clicked',
  DETAIL_GALLERY_CLICKED: 'Detail Gallery Clicked',
  DETAIL_NAVBAR_CLICKED: 'Detail Navbar Clicked',
  DETAIL_REVAMP_TEST_VIEWED: 'Detail Revamp Test Viewed',
  FILTER_ADDED: 'Filter Added',
  FILTER_PRICE_CHIP_USED: 'Filter Price Chip Used',
  FILTER_KM_CHIP_USED: 'Filter Km Chip Used',
  INSTANT_OFFER_FORM_VIEWED: 'Instant Offer Form Viewed',
  GOOGLE_ONE_TAP_SEEN: 'Google One Tap Seen',
  GOOGLE_ONE_TAP_STARTED: 'Google One Tap Started',
  LEAD_ENRICHED: 'Lead Enriched',
  LEAD_ERROR: 'Lead Error',
  MARKET_PLAYERS_ACTIONS_CLICK: 'Home Selector Tab Clicked',
  MARKET_PLAYERS_SERVICES_TAB: 'Accompaniment Home Selector Tab Clicked',
  MARKET_PLAYERS_SERVICES_CARD: 'Accompaniment Section Button Clicked',
  NAVIGATION_BETWEEN_CARDS_CLICKED: 'Navigation Between Cards Clicked',
  CONSUMPTION_DETAIL_CLICKED: 'Consumption Detail Clicked',
  EXTRA_EQUIPMENT_DETAIL_CLICKED: 'Extra Equipment Detail Clicked',
  MANUFACTURER_CERTIFIED_CLICKED: 'Certified Cars Program Clicked',
  PHOTO_DETAIL_CLICKED: 'Photo Detail Clicked',
  PRICE_DETAIL_CLICKED: 'Price Detail Clicked',
  RATINGS_VIEWED_EVENT: 'Ratings Viewed',
  SELLER_SERVICES_CLICKED: 'Dealer Services Pop Up',
  SEND_MESSAGE_BUTTON_CLICKED: 'Send Message Button Clicked',
  VEHICLE_HISTORY_CLICKED: 'Vehicle History Clicked',
  FREE_VEHICLE_HISTORY_CLICKED: 'Free Vehicle History Clicked',
  PRICE_INDICATOR_CLICKED: 'Price Indicator Clicked',
  PROMOTIONAL_SLIDER_BANNER_CLICKED: 'Promotional Slider Banner Clicked',
  RATINGS_CLICKED: 'Valoraciones Clicked',
  RATINGS_VIEWED_EVENTS: 'Valoraciones Viewed',
  RECOMMENDATION_WIDGET_CLICKED: 'Recommendation widget clicked',
  RECOMMENDATION_WIDGET_IMPRESSION_EVENT: 'Recommendation widget impression',
  RECOMMENDATION_WIDGET_VIEWABLE_IMPRESSION: 'Recommendation widget viewable impression',
  RESERVATION_INFORMATION_CLICKED: 'Reservation Information Clicked',
  RESET_PASSWORD_MODAL_CLOSE: 'Reset Password Modal Closed',
  SHORTCUT_LISTING_BUTTON_CLICKED: 'Shortcut Listing Button Clicked',
  SMARTBANNER_CLICKED: 'Smartbanner Clicked',
  SMARTBANNER_VIEWED: 'Smartbanner Viewed',
  SIGNED_IN_ERROR: 'Signed In Error',
  SIGNED_IN: 'Signed In',
  SIGNED_OUT: 'Signed Out',
  SIGNED_UP_ERROR: 'Signed Up Error',
  SIGNED_UP: 'Signed Up',
  SOCIAL_LOGIN_CLICKED_GOOGLE: 'Google Social Login Clicked',
  SOCIAL_LOGIN_CLICKED_APPLE: 'Apple Social Login Clicked',
  USER_RATING_COMPLETED: 'User Rating Completed',
  USER_RATING_ERROR: 'User Rating Error',
  NEWS_COMMENT_PUBLISH: 'News Commented',
  NEWS_COMMENT_REPLY: 'Reply News Comment',
  NEWS_SHARED_CLICKED: 'News Shared Clicked',
  NEWS_SHARED: 'News Shared',
  NEWSLETTER_CLICK: 'Receive Newsletter Clicked',
  LIST_NEWS_SAVED_CLICKED: 'List News Saved Clicked',
  LIST_NEWS_SAVED_VIEWED: 'List News Saved Viewed',
  NEWS_VIDEO_PLAYED: 'News Video Played',
  ...AD_COMPLAINT_EVENT_NAMES,
  ...AD_INSERTION_TRACKING_NAMES,
  ...INSTANT_OFFER_TRACKING_NAMES,
  ...LANDING_INSTANT_OFFER_TRACKING_NAMES,
  ...MESSAGING_EVENT_NAMES,
  ...USER_CONSENTS_TRACKING_EVENT_NAMES,
  ...VISIBILITY_PRODUCTS_TRACKING_NAMES,
  ...FAVORITES_TRACKING_NAMES,
  ...NET_ASSISTANT_TRACKING_NAMES,
  ...SELLER_SELECTOR_TRACKING_EVENT_NAMES
}

export const TRACKING_PAGE_ERRORS = {
  FIELD_ERROR: 'field error',
  NEW_AD_NO_TARGET: 'anuncio nuevo no target'
}

export const INSTANT_OFFER_FORM_NAMES_BY_C2B_ORIGINS = {
  DEFAULT: 'IO organico',
  [C2B_ORIGINS.INSTANT_OFFER_LANDING]: 'IO Landing',
  [C2B_ORIGINS.STANDALONE]: 'stand alone',
  [C2B_ORIGINS.VEHICLE_APPRAISER]: 'tasacion vehiculo'
}

export const C2B_FLOW_BY_ORIGINS = {
  [C2B_ORIGINS.BANNER_HOME]: 'c2b banner home',
  [C2B_ORIGINS.BANNER_HOME_TO_DEALERS]: 'c2b banner home to dealers',
  [C2B_ORIGINS.BANNER_HOME_TO_STANDALONE]: 'c2b banner home to standalone',
  [C2B_ORIGINS.CHAT]: 'c2b chat',
  [C2B_ORIGINS.PUBLISH_MY_AD]: 'c2b post pta',
  [C2B_ORIGINS.PUBLISHED_AD]: 'c2b my ads',
  [C2B_ORIGINS.STANDALONE]: 'c2b standalone',
  [C2B_ORIGINS.STANDALONE_EMPTY_CASE]: 'c2b standalone',
  [C2B_ORIGINS.INSTANT_OFFER_LANDING]: 'c2b landing',
  [C2B_ORIGINS.VEHICLE_APPRAISER]: 'c2b tasador',
  [C2B_ORIGINS.POST_LEAD]: 'c2b post lead'
}

const GALLERY_DETAIL_HIT_INFORMATIONS = {
  GALLERY_DETAIL_IMAGE: 'image',
  GALLERY_DETAIL_VIDEO: 'video',
  GALLERY_DETAIL_BUTTON: 'button'
}

const AD_DETAIL_HIT_INFORMATIONS = {
  AD_DETAIL_SHOW_DESCRIPTION: 'mostrar descripcion',
  AD_DETAIL_SHOW_EXTRAS: 'mostrar extras',
  AD_DETAIL_SHOW_TECHNICAL_DATASHEET: 'mostrar ficha tecnica',
  AD_DETAIL_SHOW_SELLER_ADDRESS: 'mostrar direccion'
}

const AD_INSERTION_HIT_INFORMATIONS = {
  C2B_VIDEO: 'c2b video',
  EMPTY_PLATE: 'matricula vacia',
  ONLINE_APPOINTMENT_INFO: 'informacion cita online',
  PTA_VIDEO: 'pta video',
  WRONG_PLATE: 'matricula incorrecta'
}

const INSTANT_OFFER_PAGE_HIT_INFORMATIONS = {
  HOW_INITIAL_APPRAISAL_IS_CALCULATED: 'como calculamos tasacion inicial',
  HOW_VEHICLE_VALUE_IS_CALCULATED: 'como se calcula valor vehiculo',
  PUBLISH_VEHICLE: 'publicar vehículo',
  WHY_THERE_ARE_NOT_OFFERS: 'porque no hay ofertas',
  WEEK_SCHEDULE_CLICK_ON_A_DAY: 'click en un dia',
  WEEK_SCHEDULE_CLICK_ON_DEALER_NAME: 'click en el nombre',
  WEEK_SCHEDULE_CLICK_ON_MORE_DAYS: 'click en mas dias'
}

const NET_ASSISTANT_HIT_INFORMATIONS = {
  NET_ASSISTANT_HEADER_MENU: 'header menu',
  NET_ASSISTANT_SEARCH_BAR_DROPDOWN: 'search bar dropdown'
}

const VISIBILITY_PRODUCTS_HIT_INFORMATIONS = {
  VISIBILITY_PRODUCTS_FAQS_EXPANDING: 'pregunta frecuente desplegada',
  VISIBILITY_PRODUCTS_BUY_QUICK_SALE: 'comprar venta rapida',
  VISIBILITY_PRODUCTS_BUY_TOP: 'comprar top',
  VISIBILITY_PRODUCTS_BUY_PACK_VISIBILITY: 'comprar pack visibilidad',
  VISIBILITY_PRODUCTS_HOW_QUICK_SALE_WORKS: 'como funciona venta rapida',
  VISIBILITY_PRODUCTS_HOW_TOP_WORKS: 'como funciona top',
  VISIBILITY_PRODUCTS_HOW_PACK_VISIBILITY_WORKS: 'como funciona pack visibilidad'
}

export const HIT_INFORMATIONS = {
  ADS_LIST_MENU_CLICKED: 'List 3 Point Menu Clicked',
  APP_SUGGESTION_DRAWER_CLOSE_ACTION: 'close',
  APP_SUGGESTION_DRAWER_INSTALL_ACTION: 'install',
  APP_SUGGESTION_DRAWER_POSITION_BOTTOM: 'bottom',
  CHECKED: 'checked',
  UNCHECKED: 'unchecked',
  EMAIL_AUTHENTICATION: 'email login',
  GOOGLE_AUTHENTICATION: 'google',
  GOOGLE_LOGIN: 'social login google',
  SOCIAL_LOGIN_APPLE: 'social login apple',
  GREEN_MOBILITY: 'green',
  LIFESTYLE_CATEGORIES: 'estilo de vida',
  MARKET_PLAYERS_ACTIONS_BUYER: 'Comprar',
  MARKET_PLAYERS_ACTIONS_SELLER: 'Vender',
  MARKET_PLAYERS_SERVICES_TAB_BUYER: 'comprar',
  MARKET_PLAYERS_SERVICES_TAB_SELLER: 'vender',
  MARKET_PLAYERS_SERVICES_TAB_OWNER: 'propietarios',
  NEXT: 'siguiente',
  ONLY_CHOICE: 'unica opcion',
  PREVIOUS: 'anterior',
  PROMOTIONAL_SLIDER_BANNER: 'promotional slider banner',
  PTA: 'pta',
  SMARTBANNER_CLOSE_ACTION: 'close',
  SMARTBANNER_POSITION_TOP: 'top',
  SMARTBANNER_POSITION_BOTTOM: 'bottom',
  STANDARD_LOGIN: 'email login',
  SUBSCRIPTION_AD_COMMITMENT_CLICKED: 'Subscription Commitment Button Clicked',
  SUBSCRIPTION_AD_KM_INCLUDED_CLICKED: 'Subscription Km Included Button Clicked',
  VEHICLE_CATEGORIES_SLIDER: 'categorias de vehiculos',
  ...GALLERY_DETAIL_HIT_INFORMATIONS,
  ...AD_DETAIL_HIT_INFORMATIONS,
  ...AD_INSERTION_HIT_INFORMATIONS,
  ...INSTANT_OFFER_PAGE_HIT_INFORMATIONS,
  ...VISIBILITY_PRODUCTS_HIT_INFORMATIONS,
  ...NET_ASSISTANT_HIT_INFORMATIONS
}

export const AUTHENTICATION_HIT_INFORMATIONS_2 = {
  COMPARATOR: 'comparador',
  NET: 'net assistant',
  DETAIL: 'detail',
  DEALER_STOCK_PAGE: 'dealer stock page'
}

const VISIBILITY_PRODUCTS_HIT_ORIGINS = {
  VISIBILITY_PRODUCTS_HOW_QUICK_SALE_WORKS: 'como funciona venta rapida',
  VISIBILITY_PRODUCTS_HOW_TOP_WORKS: 'como funciona top',
  VISIBILITY_PRODUCTS_HOW_PACK_VISIBILITY_WORKS: 'como funciona pack visibilidad',
  VISIBILITY_PRODUCTS_PAGE: 'pagina productos visibilidad'
}

const NET_ASSISTANT_HIT_ORIGINS = {
  NET_ASSISTANT_LANDING: 'landing',
  NET_ASSISTANT_CONVERSATION: 'conversation',
  NET_ASSISTANT_NEW_CHAT: 'new conversation',
  NET_ASSISTANT_OLD_CHAT: 'old conversation',
  NET_ASSISTANT_AD: 'anuncio',
  NET_ASSISTANT_LISTING: 'listado',
  NET_ASSISTANT_AD_FAVORITED: 'Net Ad Favorited',
  NET_ASSISTANT_END_CONVERSATION: 'end conversation'
}

export const LEAD_ERROR_HIT_INFORMATIONS = {
  MESSAGE_NOT_SENT: 'Message not sent',
  MISSING_FIELDS: 'Missing fields'
}

export const HIT_ORIGINS = {
  AD_DETAIL: 'detail',
  APP_SUGGESTION_DRAWER_ADS_LIST: 'ads list',
  APP_SUGGESTION_DRAWER_HOME: 'homepage',
  AD_DETAIL_AD_DISCARDED: 'Detail Ad Discarded',
  AD_IMAGE_GALLERY_AD_DISCARDED: 'Image Gallery Ad Discarded',
  AD_LIST_AD_DISCARDED: 'List Ad Discarded',
  ADS_LIST_MENU_AD_DISCARDED: 'List 3p Menu Ad Discarded',
  AD_DETAIL_FAVORITED: 'Detail Ad Favorited',
  AD_DETAIL_FAVORITED_PRICE_DROP: 'Detail Price Drop Ad Favorited',
  AD_DETAIL_FAVORITED_TOPBAR: 'Detail Topbar Ad Favorited',
  AD_LIST_FAVORITED: 'List Ad Favorited',
  AD_LIST_MENU_FAVORITED_PRICEDROP: 'List 3p Menu Price Drop Ad Favorited',
  AD_SHARED_AFTER_FAVORITED_DETAIL: 'Detail After Favorited Ad Shared',
  ADS_LIST: 'listado de motos',
  ADS_LIST_NEW: 'listado de motos nuevos',
  ADS_LIST_QUADS: 'listado de quads y atv',
  ADS_LIST_BUGGIES: 'listado de buggies',
  ADS_LIST_MENU: 'List Ad',
  ADS_LIST_MINIMOTOS: 'listado de minimotos',
  ADS_LIST_CLASSIC_AND_COMPETITION: 'listado de motos clasicas y competicion',
  ADS_LIST_QUADS_NEW: 'listado de quads y atv nuevos',
  ADS_LIST_BUGGIES_NEW: 'listado de buggies nuevos',
  ADS_LIST_MINIMOTOS_NEW: 'listado de minimotos nuevas',
  ALERT_AD_FAVORITED: 'Alert Ad Favorited',
  APP_DOWNLOAD_FROM_COMPARATOR: 'download from car comparison',
  APP_DOWNLOAD_FROM_FOOTER: 'download from footer',
  APP_DOWNLOAD_FROM_LOGIN_MODAL: 'download from registration via topbar',
  APP_DOWNLOAD_FROM_POST_LEAD: 'download from post lead',
  COMPARATOR_AD_FAVORITED: 'Comparator',
  DEALER_PROVINCE_SEARCH_PHONE_CALLED: 'Dealer Province Search Phone Called',
  DEALER_SEARCH_PHONE_CALLED: 'Dealer Search Phone Called',
  DEFAULT_LOGIN: 'default login',
  LEAD_EMAIL: 'lead email',
  FAVORITES_PAGE: 'my favorites',
  FAVORITES_DEALER_PAGE: 'my favorite dealers page',
  GOOGLE_ONE_TAP: 'google one tap',
  HOME_PAGE: 'homepage',
  HOME_PAGE_SEARCH: 'homepage filters',
  LIST: 'list',
  LIST_ADS_COMPARISON_MENU: 'comparison menu',
  NEWS_COMMENTED: 'News Below Commented',
  NEWS_DETAIL_REFERER: 'editorial web',
  NEWS_LIST: 'news',
  NEWS_SAVED_LIST: 'news saved',
  NEWSLETTER_NEWS_DETAIL_BODY: 'News body',
  NEWSLETTER_HOME: 'homepage',
  NEWSLETTER_NEWS_LIST: 'news list',
  NEWSLETTER_AD_DETAIL: 'ad detail',
  PTA: 'pta',
  RATING_LINK: 'link',
  RATING_TAB: 'tab',
  RATING_DETAIL: 'detail',
  RATING_DETAIL_CONTACT_FORM: 'detail contact form',
  SMARTBANNER_HOME: 'homepage',
  SMARTBANNER_ADS_LIST: 'ads list',
  SMARTBANNER_AD_DETAIL: 'ad detail',
  SMARTBANNER_NEWS_LIST: 'news list',
  SMARTBANNER_NEWS_DETAIL: 'news detail',
  SOCIAL_LOGIN: 'social login',
  USER_PROFILE: 'mi cuenta',
  LEAD_WHATSAPP: 'lead whatsapp',
  TOP_BAR_BUTTON: 'top bar button',
  AD_FAVORITED: 'add ad favorited',
  DEALER_FAVORITED: 'add dealer favorited',
  PRICE_DROP_SAVED: 'save price drop',
  AD_DISCARDED: 'ad discarded',
  NEWSLETTER_SUBSCRIPTION: 'subscribe newsletter',
  NEWS_COMMENT: 'comment from editorial',
  MY_ACCOUNT: 'my account',
  SEARCH_SAVED: 'save search',
  CONFIGURATOR: 'configurator',
  RESERVATION: 'reservation',
  OTHERS: 'others',
  LOGIN_PAGE: 'login page',
  DETAIL_PAGE: 'detail_page',
  DETAIL_DRAWER: 'detail_drawer',
  DETAIL_PAGE_CONTACT_DRAWER: 'detail_page_contact_drawer',
  CHAT_LEAD: 'chat lead',
  AD_REPLIED_EMAIL_ALERT_CREATED: 'Ad Replied Email Alert Created',
  ...VISIBILITY_PRODUCTS_HIT_ORIGINS,
  ...NET_ASSISTANT_HIT_ORIGINS
}

export const SEARCH_AI_USED_HIT_ORIGINS_BY_PAGE_NAME = {
  [ADS_LIST_PAGE_NAME]: HIT_ORIGINS.ADS_LIST,
  [ADS_LIST_NEW_PAGE_NAME]: HIT_ORIGINS.ADS_LIST,
  [ADS_LIST_QUADS_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_QUADS,
  [ADS_LIST_BUGGIES_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_BUGGIES,
  [ADS_LIST_MINIMOTOS_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_MINIMOTOS,
  [ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_CLASSIC_AND_COMPETITION,
  [ADS_LIST_QUADS_NEW_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_QUADS_NEW,
  [ADS_LIST_BUGGIES_NEW_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_BUGGIES_NEW,
  [ADS_LIST_MINIMOTOS_NEW_PAGE_NAME]: HIT_ORIGINS.ADS_LIST_MINIMOTOS_NEW,
  [HOME_PAGE_NAME]: HIT_ORIGINS.HOME_PAGE
}

export const LIST_TYPES = {
  NET_ASSISTANT_CAROUSEL: 'carrousel respuesta net',
  NET_ASSISTANT_AD_CARD: 'ad card respuesta net',
  RECOMMENDATIONS_DEALER_RATING_NOT_ANSWERED: 'dealer rating not answered anuncios recomendados'
}

export const RECOMMENDATIONS_PAGE_LIST_TYPES_BY_TARGET = {
  [RECOMMENDATIONS_TARGETS.DEALER_NO_RESPONSE]: LIST_TYPES.RECOMMENDATIONS_DEALER_RATING_NOT_ANSWERED
}

export const TRACKING_EVENT_CONTEXTS = {
  FAVORITES_AD_DELETED: 'favorites-ad-deleted',
  FAVORITES_LIST: 'favorites-list',
  GOOGLE_LOGIN: 'google-social-login',
  APPLE_LOGIN: 'apple-social-login',
  LISTING_AD_VIEWED: 'listing-ad-viewed',
  LISTING_FEW_RESULTS: 'listing-few-results',
  STANDARD_LOGIN: 'standard-login'
}

export const RECOMMENDED_TRACKING_EVENT_CONTEXTS = {
  [TRACKING_EVENT_CONTEXTS.FAVORITES_AD_DELETED]: 'favorites_ad_deleted',
  [TRACKING_EVENT_CONTEXTS.FAVORITES_LIST]: 'favorites_list',
  [TRACKING_EVENT_CONTEXTS.LISTING_AD_VIEWED]: 'listing_ad_viewed',
  [TRACKING_EVENT_CONTEXTS.LISTING_FEW_RESULTS]: 'listing_few_results'
}

export const TRACKING_EVENT_DATA_DEFAULT_PRODUCT = {
  ad_impression: 1,
  category: 'ads',
  highlight_type: 'not_highlighted',
  price: 0,
  quantity: 0
}

export const ADS_DETAIL_PAGE_TYPE = 'detail'
export const ADS_LIST_PAGE_TYPE = 'list'

export const TRACKING_DATA_BY_PAGE = {
  HOME: {
    channel: 'homepage',
    page_type: 'landing',
    page_category_level1: 'homepage',
    event: 'Home Viewed'
  },
  NET_ASSISTANT: {
    channel: 'assistant',
    page_type: 'form',
    page_category_level1: 'assistant',
    event: PAGE_VIEW_EVENT
  },
  NET_ASSISTANT_MENU: {
    channel: 'assistant',
    page_type: 'form',
    page_category_level1: 'assistant',
    event: PAGE_VIEW_EVENT
  },
  INSTANT_OFFER_STANDALONE: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'oferta instantanea',
    event: TRACKING_EVENT_NAMES.INSTANT_OFFER_FORM_VIEWED
  },
  INSTANT_OFFER_WITH_PLATE: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'oferta instantanea',
    page_name: 'proceso matricula io formulario',
    event: TRACKING_EVENT_NAMES.INSTANT_OFFER_FORM_VIEWED
  },
  INSTANT_OFFER_SELL_TO_DEALER: {
    channel: 'ad post',
    event: 'Ad Insertion IO Viewed',
    page_category_level1: 'oferta instantanea',
    page_name: 'propuesta instant offer',
    page_type: 'form'
  },
  NEWS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_category_level2: 'portada',
    event: 'List News Viewed'
  },
  NEWS_SAVED: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_name: 'listado de noticias guardadas',
    event: TRACKING_EVENT_NAMES.LIST_NEWS_SAVED_VIEWED
  },
  NEWS_DETAIL: {
    channel: 'editorial',
    page_type: 'detail',
    page_category_level1: 'noticias',
    event: 'Detail News Viewed'
  },
  NEWS_DETAIL_GALLERY: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'galeria',
    event: PAGE_VIEW_EVENT
  },
  NEWS_DETAIL_GALLERY_IMAGE: {
    channel: 'editorial',
    page_type: 'detail',
    page_category_level1: 'galeria',
    event: PAGE_VIEW_EVENT
  },
  NEWS_COMMENTS: {
    channel: 'editorial',
    page_type: 'information',
    page_category_level1: 'noticias',
    event: PAGE_VIEW_EVENT
  },
  NEWS_GALLERY_SEARCH: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'galeria',
    event: PAGE_VIEW_EVENT
  },
  NEWS_RSS_FEEDS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'rss',
    event: PAGE_VIEW_EVENT
  },
  NEWS_NEWSLETTER: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'boletin',
    event: PAGE_VIEW_EVENT
  },
  NEWS_SECTION_TIPS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_category_level2: 'consejos',
    event: 'List News Viewed'
  },
  NEWS_SECTION_TRENDS: {
    channel: 'editorial',
    page_type: 'list',
    page_category_level1: 'noticias',
    page_category_level2: 'tendencias',
    event: 'List News Viewed'
  },
  ADS_LIST_FILTERS: {
    channel: 'ads',
    page_type: 'form',
    event: LIST_FILTERS_VIEW_EVENT
  },
  ADS_LIST: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'motos'
  },
  ADS_LIST_QUADS: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'quads y atv'
  },
  ADS_LIST_BUGGIES: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'buggies'
  },
  ADS_LIST_MINIMOTOS: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'minimotos'
  },
  ADS_LIST_CLASSIC_AND_COMPETITION: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'clasicas y competicion'
  },
  ADS_LIST_NEW: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'motos'
  },
  ADS_LIST_QUADS_NEW: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'quads y atv'
  },
  ADS_LIST_BUGGIES_NEW: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'buggies'
  },
  ADS_LIST_MINIMOTOS_NEW: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'minimotos'
  },
  // even if subscription for motorcycles does not exist yet, we leave it here for compatibility
  ADS_LIST_SUBSCRIPTION: {
    ...COMMON_ADS_LIST,
    page_category_level1: 'motos'
  },
  ADS_DETAIL: {
    channel: 'ads'
  },
  LENDO: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'lendo',
    event: PAGE_VIEW_EVENT
  },
  DEALERS_LIST: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'concesionarios',
    event: PAGE_VIEW_EVENT
  },
  DEALERS_LIST_RESULTS: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'concesionarios',
    event: PAGE_VIEW_EVENT
  },
  DEALER_RATING_STEP_0: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STEP_1: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STEP_2: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STEP_3: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'form',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STATE_SUCCESS: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STATE_EXPIRED: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'user rating'
  },
  DEALER_RATING_STATE_CLOSED: {
    channel: 'rating',
    event: PAGE_VIEW_EVENT,
    page_type: 'information',
    page_category_level1: 'user rating'
  },
  MAKE: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MAKES_DISTRIBUTOR: {
    channel: 'model detail',
    page_type: 'landing',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MODEL_DETAIL: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MODEL_DETAIL_INTERIOR: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  MODEL_DETAIL_TRUNK: {
    channel: 'model detail',
    page_type: 'list',
    page_category_level1: 'model detail',
    event: PAGE_VIEW_EVENT
  },
  ERROR: {
    channel: 'others',
    page_type: 'error page',
    page_category_level1: 'error page',
    event: 'Error Page Viewed'
  },
  PROFESSIONAL_STOCK: {
    channel: 'professional stock',
    page_type: 'list',
    event: LIST_VIEW_EVENT
  },
  PROFESSIONALS: {
    channel: 'professional area',
    page_type: 'landing',
    page_category_level1: 'landing',
    event: PAGE_VIEW_EVENT
  },
  RECOMMENDATIONS: {
    event: LIST_VIEW_EVENT
  },
  USER_ADS: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'anuncios',
    event: 'My Ads Viewed'
  },
  USER_ADS_BUMP: {
    channel: 'payment',
    page_type: 'form',
    page_category_level1: 'visibilidad anuncio',
    event: 'Product List Viewed'
  },
  COMPARADOR: {
    channel: 'comparator',
    page_type: 'list',
    event: PAGE_VIEW_EVENT
  },
  USER_FAVORITE_ADS: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'favoritos',
    event: PAGE_VIEW_EVENT
  },
  USER_FAVORITE_DEALERS: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'favoritos',
    page_category_level2: 'concesionarios',
    event: PAGE_VIEW_EVENT
  },
  USER_SAVED_SEARCHES: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'busquedas',
    event: 'My Alerts Viewed'
  },
  USER_MESSAGING: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'mensajes',
    event: 'My Messaging Inbox Viewed'
  },
  USER_PROFILE: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'cuenta',
    event: PAGE_VIEW_EVENT
  },
  USER_PROFILE_EDIT: {
    channel: 'my account',
    event: 'Edit Account Viewed',
    page_category_level1: 'editar',
    page_type: 'form'
  },
  USER_ACCOUNT: {
    channel: 'my account',
    page_type: 'list',
    page_category_level1: 'cuenta',
    event: PAGE_VIEW_EVENT
  },
  USER_ACCOUNT_EDIT: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'editar',
    event: 'Edit Account Viewed'
  },
  USER_ACCOUNT_DELETE: {
    channel: 'my account',
    page_type: 'popup',
    page_category_level1: 'editar',
    event: 'Edit Account Viewed'
  },
  USER_ACCOUNT_TAKE_OUT: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'editar',
    event: 'Edit Account Viewed'
  },
  USER_ALERTS_MATCHES: {
    channel: 'my account',
    eventName: 'List Viewed',
    pageCategoryLevel1: 'motos',
    pageName: 'novedades de alertas',
    pageType: 'list'
  },
  USER_VALIDATED_ACCOUNT: {
    channel: 'my account',
    page_type: 'information',
    page_category_level1: 'validacion',
    event: PAGE_VIEW_EVENT
  },
  USER_AD_DELETION_FORM: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'eliminar anuncio',
    event: PAGE_VIEW_EVENT,
    event_name: 'ad_delete_form'
  },
  USER_AD_EDIT: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'editar anuncio',
    event: PAGE_VIEW_EVENT,
    event_name: 'ad_modification_form'
  },
  USER_INCORRECT_EMAIL_OR_PHONE: {
    channel: 'ad post',
    page_type: 'information',
    page_category_level1: 'error anuncio',
    event: PAGE_VIEW_EVENT
  },
  PAYMENT_AD_REQUEST: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'segundo anuncio',
    event: 'Product List Viewed'
  },
  PAYMENT_CONFIRMATION: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'confirmacion',
    event: 'Order Completed'
  },
  SEARCH_ADVICES: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'tramites compra venta',
    event: PAGE_VIEW_EVENT
  },
  TERMS_OF_SERVICE: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'condiciones de uso',
    event: PAGE_VIEW_EVENT
  },
  DATA_PROTECTION: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'politica de privacidad',
    event: PAGE_VIEW_EVENT
  },
  VIDEOS_POLICY: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'normas de video',
    event: PAGE_VIEW_EVENT
  },
  BUYING_SAFELY: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'guia de seguridad',
    event: PAGE_VIEW_EVENT
  },
  SITEMAP: {
    channel: 'information',
    page_type: 'information',
    page_category_level1: 'mapa web',
    event: PAGE_VIEW_EVENT
  },
  CONTACT: {
    channel: 'information',
    page_type: 'form',
    page_category_level1: 'contacto',
    event: PAGE_VIEW_EVENT
  },
  PUBLISH_MY_AD: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio',
    event: 'Ad Insertion Viewed'
  },
  PUBLISH_MY_AD_CATEGORY: {
    event: 'Ad Insertion Viewed',
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio'
  },
  EDIT_MY_AD: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio',
    event: 'Ad Modify Viewed'
  },
  PUBLISH_YOUR_VEHICLE: {
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio',
    event: 'Seller Selector Viewed'
  },
  PUBLISH_YOUR_VEHICLE_WITH_PLATE: {
    event: 'Ad Insertion Viewed',
    channel: 'ad post',
    page_type: 'form',
    page_category_level1: 'crear anuncio'
  },
  TECHNICAL_DETAILS: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'homepage',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_COMPARATOR: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_COMPARATOR_RESULTS: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_MAKE: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'marca',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_MODEL: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'modelo',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_BODY_TYPE: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'carroceria',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_VERSION: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'ficha',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_VEHICLE: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'ficha',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'ficha',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_SEARCH: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'buscador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_SEARCH_RESULTS: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'buscador',
    event: PAGE_VIEW_EVENT
  },
  TECHNICAL_DETAILS_SEARCH_ENGINE: {
    channel: 'services',
    page_type: 'list',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'buscador',
    event: PAGE_VIEW_EVENT
  },
  COMPARISON: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  COMPARISON_RESULT: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'fichas tecnicas',
    page_category_level2: 'comparador',
    event: PAGE_VIEW_EVENT
  },
  APPRAISAL: {
    channel: 'services',
    page_type: 'form',
    page_category_level1: 'tasacion',
    event: PAGE_VIEW_EVENT
  },
  APPRAISAL_VEHICLE: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'tasacion',
    event: PAGE_VIEW_EVENT
  },
  INSPECTION_CENTERS: {
    channel: 'services',
    page_type: 'detail',
    page_category_level1: 'centros itv',
    event: PAGE_VIEW_EVENT
  },
  WDYL: {
    channel: 'what do you love',
    page_type: 'list',
    page_category_level1: 'what do you love',
    event: 'What Do You Love Viewed'
  },
  PROFESSIONALS_LOGIN: {
    channel: 'professional area',
    page_type: 'form',
    page_category_level1: 'login',
    event: PAGE_VIEW_EVENT
  },
  PROFESSIONALS_REGISTER: {
    channel: 'professional area',
    page_type: 'form',
    page_category_level1: 'profesionales',
    event: PAGE_VIEW_EVENT
  },
  PROFESSIONALS_INFO: {
    channel: 'professional area',
    page_type: 'information',
    page_category_level1: 'profesionales',
    event: PAGE_VIEW_EVENT
  },
  PROFESSIONALS_INFO_EXTENDED: {
    channel: 'professional area',
    page_type: 'information',
    page_category_level1: 'profesionales',
    event: PAGE_VIEW_EVENT
  },
  LOGIN_ERROR: {
    event: 'Signed In Error'
  },
  LINK_ACCOUNT_ERROR: {
    event: 'Signed In Error'
  },
  REGISTER_ERROR: {
    event: 'Signed Up Error'
  },
  REGISTER_VALIDATION_ERROR: {
    event: 'Signed Up Error'
  },
  COMPLETE_REGISTRATION_ERROR: {
    event: 'Signed Up Error'
  },
  FORGOT_PASSWORD_ERROR: {
    event: 'Password Email Error'
  },
  PASSWORD_RESET_ERROR: {
    event: 'Password Reseted Error'
  },
  LOGIN: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Login Viewed'
  },
  REGISTER: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Register Viewed'
  },
  FORGOT_PASSWORD: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Page Viewed'
  },
  PASSWORD_RESET: {
    channel: 'my account',
    page_type: 'form',
    page_category_level1: 'login',
    event: 'Page Viewed'
  },
  REGISTER_SUCCESS: {
    event: 'Signed Up',
    hit_origin: 'default login',
    hit_information: 'email login'
  },
  FORGOT_PASSWORD_SEND: {
    event: 'Password Email Sent'
  },
  PASSWORD_RESET_SUCCESS: {
    event: 'Password Reseted'
  },
  CHECKOUT: {
    channel: 'payment',
    page_type: 'form',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Started'
  },
  CHECKOUT_SUCCESS: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Order Completed'
  },
  CHECKOUT_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Payment Error'
  },
  CHECKOUT_PENDING: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Pending'
  },
  CHECKOUT_ACTIVATION_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Activation Error'
  },
  CHECKOUT_REFUND_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Refund Error'
  },
  CHECKOUT_REQUEST_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Request Error'
  },
  CHECKOUT_UNKNOWN_ERROR: {
    channel: 'payment',
    page_type: 'information',
    page_category_level1: 'plataforma pago',
    event: 'Checkout Error',
    page_error: 'Checkout Unknown Error'
  },
  PRODUCTS: {
    channel: 'payment',
    page_type: 'form',
    page_category_level1: 'visibilidad anuncio',
    event: 'Product List Viewed'
  },
  INSURANCE: {
    channel: 'marketplace insurances',
    event: INSURANCES_VIEW_EVENT
  }
}
export const TRACKING_TRANSLATIONS_BY_CULTURE = {
  [DEFAULT_CULTURE]: {
    // Page Names
    ADS_DETAIL_ERROR_PAGE_NAME: 'informar de un error',
    ADS_DETAIL_PAGE_NAME: 'detail',
    ADS_DETAIL_RELATED_ADS_POPUP_CONTACT_TYPE_CALL: 'telefono',
    ADS_DETAIL_RELATED_ADS_POPUP_CONTACT_TYPE_MAIL: 'mail',
    ADS_DETAIL_RELATED_ADS_POPUP_PAGE_NAME: 'anuncios recomendados',
    ADS_LIST_BUGGIES_NEW_PAGE_NAME: 'listado de buggies nuevos',
    ADS_LIST_BUGGIES_PAGE_NAME: 'listado de buggies',
    ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME: 'listado de motos clasicas y competicion',
    ADS_LIST_FILTERS_PAGE_NAME: 'filtros',
    ADS_LIST_MINIMOTOS_NEW_PAGE_NAME: 'listado de minimotos nuevas',
    ADS_LIST_MINIMOTOS_PAGE_NAME: 'listado de minimotos',
    ADS_LIST_NEW_PAGE_NAME: 'listado de motos nuevas',
    ADS_LIST_PAGE_NAME: 'listado de motos',
    ADS_LIST_QUADS_NEW_PAGE_NAME: 'listado de quads y atv nuevos',
    ADS_LIST_QUADS_PAGE_NAME: 'listado de quads y atv',
    ADS_LIST_SUBSCRIPTION_PAGE_NAME: 'listado de motos por suscripcion', // even if subscription for motorcycles does not exist yet, we leave it here for compatibility
    ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME: 'listado de coches por suscripcion empresas',
    APPRAISAL_PAGE_NAME: 'tasacion de motos',
    APPRAISAL_VEHICLE_PAGE_NAME: 'resultado tasacion',
    BUYING_SAFELY_PAGE_NAME: 'guia de seguridad estafas de internet como detectarlas',
    CHECKOUT_ACTIVATION_ERROR_PAGE_NAME: 'producto contratado activacion error',
    CHECKOUT_ERROR_PAGE_NAME: 'producto contratado error',
    CHECKOUT_PAGE_NAME: 'pago seguro',
    CHECKOUT_PENDING_PAGE_NAME: 'producto contratado pendiente',
    CHECKOUT_REFUND_ERROR_PAGE_NAME: 'producto contratado reembolso error',
    CHECKOUT_REQUEST_ERROR_PAGE_NAME: 'producto contratado peticion error',
    CHECKOUT_UNKNOWN_ERROR_PAGE_NAME: 'producto contratado error desconocido',
    CHECKOUT_SUCCESS_PAGE_NAME: 'producto contratado',
    COMPARISON_PAGE_NAME: 'comparador de motos nuevas y descatalogadas',
    COMPARISON_RESULT_PAGE_NAME: 'resultados de la comparacion',
    CONTACT_PAGE_NAME: 'contactar motosnet',
    DATA_PROTECTION_PAGE_NAME: 'ley de proteccion de datos',
    DEALERS_LIST_PAGE_NAME: 'busqueda de concesionario',
    DEALERS_LIST_RESULTS_PAGE_NAME: 'busqueda de concesionario',
    DEALER_RATING_STEP_0_PAGE_NAME: 'user rating response check',
    DEALER_RATING_STEP_1_PAGE_NAME: 'user rating step 1 score',
    DEALER_RATING_STEP_2_PAGE_NAME: 'user rating step 2 tags',
    DEALER_RATING_STEP_3_PAGE_NAME: 'user rating step 3 review',
    DEALER_RATING_STATE_SUCCESS_PAGE_NAME: 'rating completed',
    DEALER_RATING_STATE_EXPIRED_PAGE_NAME: 'user rating expired',
    DEALER_RATING_STATE_CLOSED_PAGE_NAME: 'user rating closed',
    ERROR_PAGE_NAME: 'error page',
    FORGOT_PASSWORD_PAGE_NAME: 'mail para restablecer contraseña',
    HOME_PAGE_NAME: 'homepage',
    INSPECTION_CENTERS_PAGE_NAME: 'busca tu centro itv mas cercano',
    INSTANT_OFFER_STANDALONE_PAGE_NAME: 'insertion datos instant offer stand alone pagina 1',
    INSURANCE_PAGE_NAME: 'marketplace insurances',
    LENDO_PAGE_NAME: 'lendo',
    LOGIN_PAGE_NAME: 'inicia sesion',
    MAKE_PAGE_NAME: 'Model Detail - Make',
    MAKES_DISTRIBUTOR_PAGE_NAME: 'Model Detail',
    MODEL_DETAIL_PAGE_NAME: 'Model Detail - Model',
    MODEL_DETAIL_INTERIOR_PAGE_NAME: 'Model Detail - Interior',
    MODEL_DETAIL_TRUNK_PAGE_NAME: 'Model Detail - Maletero',
    NET_ASSISTANT_PAGE_NAME: 'net assistant',
    NET_ASSISTANT_MENU_PAGE_NAME: 'net assistant menu',
    NEWS_CATEGORY_PAGE_NAME: '%{category} de motos',
    NEWS_DETAIL_COMMENTS_PAGE_NAME: 'opiniones de noticia',
    NEWS_DETAIL_GALLERY_IMAGE_PAGE_NAME: 'detalle fotos de motos',
    NEWS_DETAIL_GALLERY_PAGE_NAME: 'galeria completa',
    NEWS_GALLERY_SEARCH_PAGE_NAME: 'fotos de motos',
    NEWS_HOME_PAGE_NAME: 'actualidad del motor',
    NEWS_NEWSLETTER_PAGE_NAME: 'boletines de motos.net',
    NEWS_RSS_FEEDS_PAGE_NAME: 'rss de las ultimas noticias de motor',
    NEWS_SEARCH_PAGE_NAME: 'actualidad del motor',
    NEWS_SECTION_TIPS_PAGE_NAME: 'consejos de coches',
    NEWS_SECTION_TRENDS_PAGE_NAME: 'tendencias de coches',
    NEWS_TAG_PAGE_NAME: 'actualidad del motor',
    NO_RESULTS_PAGE_NAME: 'listado sin resultados',
    PASSWORD_RESET_PAGE_NAME: 'restablece tu contraseña',
    PAYMENT_AD_REQUEST_PAGE_NAME: 'segundo anuncio',
    PAYMENT_CONFIRMATION_PAGE_NAME: 'producto contratado',
    PUBLISH_YOUR_VEHICLE_PAGE_NAME: 'acceso a publicar',
    PRODUCTS_PAGE_NAME: 'dale mas visibilidad a tu anuncio',
    PROFESSIONAL_STOCK_CATEGORY_LEVEL_1: 'concesionario',
    PROFESSIONAL_STOCK_INFO_PAGE_NAME: 'informacion del dealer',
    PROFESSIONAL_STOCK_PAGE_NAME: 'listado de concesionario',
    PROFESSIONAL_STOCK_INACTIVE_PAGE_NAME: 'listado de concesionario inactivo',
    PROFESSIONALS_INFO_EXTENDED_PAGE_NAME: 'pack ev basico coches mas informacion',
    PROFESSIONALS_INFO_PAGE_NAME: 'pack ev basico coches',
    PROFESSIONALS_LOGIN_PAGE_NAME: 'login',
    PROFESSIONALS_PAGE_NAME: 'landing profesionales',
    PROFESSIONALS_REGISTER_PAGE_NAME: 'crear cuenta para profesionales',
    PUBLISH_MY_AD_PAGE_NAME: 'pon tu anuncio',
    PUBLISH_MY_AD_CATEGORY_PAGE_NAME: 'seleccion categoria',
    EDIT_MY_AD_PAGE_NAME: 'editar anuncio',
    RECOMMENDATIONS_PAGE_NAME: 'anuncios recomendados',
    REGISTER_PAGE_NAME: 'crear cuenta',
    SEARCH_ADVICES_PAGE_NAME: 'tramites para la compra-venta de motos',
    SITEMAP_PAGE_NAME: 'mapa web de motos.net',
    TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME: 'fichas tecnicas de un modelo con motor',
    TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME: 'comparador de motos',
    TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME: 'comparador de motos',
    TECHNICAL_DETAILS_MAKE_PAGE_NAME: 'fichas tecnicas de una marca',
    TECHNICAL_DETAILS_MODEL_PAGE_NAME: 'fichas tecnicas de un modelo',
    TECHNICAL_DETAILS_PAGE_NAME: 'caracteristicas, precios y fotos de los modelos actuales',
    TECHNICAL_DETAILS_SEARCH_ENGINE_PAGE_NAME: 'buscador fichas tecnicas',
    TECHNICAL_DETAILS_SEARCH_PAGE_NAME: 'buscador fichas tecnicas',
    TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME: 'buscador fichas tecnicas',
    TECHNICAL_DETAILS_VEHICLE_PAGE_NAME: 'detalle de ficha tecnica',
    TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME: 'detalle de ficha tecnica',
    TECHNICAL_DETAILS_VERSION_PAGE_NAME: 'detalle resumen de ficha tecnica',
    TERMS_OF_SERVICE_PAGE_NAME: 'condiciones generales de uso de motos.net',
    TRANSPARENCY_PAGE_NAME: 'transparencia de Motos.net',
    TIPS_PAGE_NAME: 'consejos de motos',
    // TODO: delete
    USER_ACCOUNT_DELETE_PAGE_NAME: 'borrar cuenta',
    USER_ACCOUNT_EDIT_PAGE_NAME: 'editar mis datos',
    USER_ACCOUNT_PAGE_NAME: 'mi cuenta',
    USER_ACCOUNT_TAKE_OUT_PAGE_NAME: 'take out',
    USER_AD_DELETION_FORM_PAGE_NAME: 'elimina tu anuncio',
    USER_AD_EDIT_PAGE_NAME: 'edita tu anuncio',
    USER_ADS_BUMP_PAGE_NAME: 'dale mas visibilidad a tu anuncio',
    USER_ADS_PAGE_NAME: 'mis anuncios',
    COMPARADOR_PAGE_NAME: 'comparator',
    USER_FAVORITE_ADS_PAGE_NAME: 'mis favoritos',
    USER_FAVORITE_DEALERS_PAGE_NAME: 'mis dealers favoritos',
    USER_INCORRECT_EMAIL_OR_PHONE_PAGE_NAME: 'telefono o email no valido',
    USER_MESSAGING_PAGE_NAME: 'mensajes',
    USER_PROFILE_PAGE_NAME: 'mi cuenta',
    USER_PROFILE_EDIT_PAGE_NAME: 'editar mis datos',
    USER_SAVED_SEARCHES_PAGE_NAME: 'alertas',
    USER_VALIDATED_ACCOUNT_PAGE_NAME: 'cuenta validada',
    VIDEOS_POLICY_PAGE_NAME: 'normas de publicacion de imagenes y videos',
    WDYL_PAGE_NAME: 'todo lo que tenemos en motosnet',
    // List types START
    AD_DETAIL_DEALER_ADS_LIST_TYPE: 'carrousel de detalle stock dealer',
    AD_DETAIL_RELATED_ADS_LIST_TYPE: 'carrousel de detalle',
    ADS_DETAIL_RELATED_ADS_POPUP_LIST_TYPE: 'popup anuncios recomendados',
    ADS_LIST_BUGGIES_NEW_TYPE: 'listado de buggies nuevos',
    ADS_LIST_BUGGIES_TYPE: 'listado de buggies',
    ADS_LIST_CLASSIC_AND_COMPETITION_TYPE: 'listado de motos clasicas y competicion',
    ADS_LIST_MINIMOTOS_NEW_TYPE: 'listado de minimotos nuevas',
    ADS_LIST_MINIMOTOS_TYPE: 'listado de minimotos',
    ADS_LIST_NEW_TYPE: 'listado de motos nuevas',
    ADS_LIST_QUADS_NEW_TYPE: 'listado de quads y atv nuevos',
    ADS_LIST_QUADS_TYPE: 'listado de quads y atv',
    ADS_LIST_RECOMMENDED_ADS_CAROUSEL_FROM_AD_AD_VIEW_LIST_TYPE: 'carrousel listado motos anuncios recomendados',
    ADS_LIST_RECOMMENDED_ADS_CAROUSEL_LIST_TYPE: 'carrousel listado 5 o menos ads anuncios recomendados',
    ADS_LIST_SUBSCRIPTION_TYPE: 'listado de motos por suscripcion', // even if subscription for motorcycles does not exist yet, we leave it here for compatibility
    ADS_LIST_BUSINESS_SUBSCRIPTION_TYPE: 'listado de coches por suscripcion empresas',
    ADS_LIST_TYPE: 'listado de motos',
    NEWS_LIST_TYPE: 'carrousel de noticias',
    PROFESSIONAL_STOCK_TYPE: 'listado de concesionario',
    USER_FAVORITE_ADS_TYPE: 'listado de favoritos',
    USER_FAVORITE_RECOMMENDED_ADS_CAROUSEL_LIST_TYPE: 'carrousel listado favoritos anuncios recomendados',
    USER_FAVORITE_RECOMMENDED_ADS_POPUP_LIST_TYPE: 'listado favoritos ad dropped anuncios recomendados'
    // List types END
  }
}

export const OFFER_TYPES_TRANSLATIONS = {
  [OFFER_TYPE_SECOND_HAND]: {[DEFAULT_CULTURE]: 'Ocasión'},
  [OFFER_TYPE_NEW]: {[DEFAULT_CULTURE]: 'Nuevo'}
}

export const CATEGORIES_LEVEL_1_TRANSLATIONS = {
  [MOTOS_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Motos'},
  [QUADS_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Quads y atv'},
  [BUGGIES_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Buggies'},
  [MINIMOTOS_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Minimotos'},
  [CLASSICS_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Clasicas y competicion'}
}

export const CATEGORIES_LEVEL_2_TRANSLATIONS = {
  [CATEGORY2_ID_MOTORCYCLE]: {[DEFAULT_CULTURE]: 'Ciclomotor'},
  [CATEGORY2_ID_SCOOTER]: {[DEFAULT_CULTURE]: 'Scooter'},
  [CATEGORY2_ID_ROAD]: {[DEFAULT_CULTURE]: 'Carretera'},
  [CATEGORY2_ID_OFFROAD]: {[DEFAULT_CULTURE]: 'Off-road'},
  [QUADS_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Quads y ATV'},
  [CLASSICS_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Clásicas y competición'},
  [CATEGORY2_ID_MOTO_PARTS]: {
    [DEFAULT_CULTURE]: 'Recambios y despiece de motos'
  },
  [CATEGORY2_ID_MOTO_CLOTHING]: {
    [DEFAULT_CULTURE]: 'Ropa y complementos para el motorista'
  },
  [CATEGORY2_ID_WHEELS]: {[DEFAULT_CULTURE]: 'Neumáticos y llantas'},
  [CATEGORY2_ID_TRUNK]: {[DEFAULT_CULTURE]: 'Maletas y baúles'},
  3400: {[DEFAULT_CULTURE]: 'Despieces'},
  [BUGGIES_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Buggy'},
  [MINIMOTOS_CATEGORY1_ID]: {[DEFAULT_CULTURE]: 'Minimoto'}
}

export const LEAD_TYPES = {
  AD_REPLIED_CHAT: 'Ad Replied Chat',
  ALERT_MATCH_AD_REPLIED_CHAT: 'Alert Match Ad Replied Chat',
  ALERT_MATCH_PHONE_CALLED: 'Alert Match Phone Called',
  APPOINTMENT_AD_REPLIED_EMAIL: 'Appointment Ad Replied Email',
  DETAIL_AD_REPLIED_CHAT: 'Detail Ad Replied Chat',
  DETAIL_AD_REPLIED_EMAIL: 'Detail Ad Replied Email',
  DETAIL_AD_REPLIED_WHATSAPP: 'Detail Ad Replied Whatsapp',
  DETAIL_PHONE_CALLED: 'Detail Phone Called',
  FAVORITE_AD_REPLIED_CHAT: 'Favorite Ad Replied Chat',
  FAVORITE_PHONE_CALLED: 'Favorite Phone Called',
  FINANCED_PURCHASE_EMAIL: 'Financed Purchase Email',
  LAST_PICTURE_PHONE_CALLED: 'Last Picture Phone Called',
  MODEL_DETAIL_LEAD: 'Lead to OEM',
  PHONE_SENT_CHAT: 'Phone Sent Chat',
  PROFESSIONAL_LANDING_PHONE_CALLED: 'Professional Landing Phone Called',
  PROFESSIONAL_STOCK_AD_REPLIED_EMAIL: 'Professional Stock Ad Replied Email',
  PROFESSIONAL_STOCK_INFO_AD_REPLIED_EMAIL: 'Dealer Information Replied Email',
  PROFESSIONAL_STOCK_PHONE_CALLED: 'Professional Stock Phone Called',
  RECENT_SEARCH_AD_REPLIED_CHAT: 'Recent Search Ad Replied Chat',
  RECENT_SEARCH_PHONE_CALLED: 'Recent Search Phone Called',
  RECOMMENDED_AD_REPLIED_EMAIL: 'Recommended Ad Replied Email',
  RECOMMENDED_PHONE_CALLED: 'Recommended Phone Called',
  RESERVATION_PAYMENT_CONFIRMED_PHONE_CALLED: 'Reservation Payment Confirmed Phone Called',
  SAVED_FAVORITE_AD_REPLIED_CHAT: 'Saved Favorite Ad Replied Chat',
  SAVED_FAVORITE_PHONE_CALLED: 'Saved Favorite Phone Called',
  SAVED_FAVORITE_DEALER_EMAIL: 'Favorite Dealer Email',
  COMPARATOR_EMAIL: 'Comparator Email',
  COMPARATOR_PHONE_CALLED: 'Comparator Phone Called',
  NET_AD_DETAIL_EMAIL: 'Net Email',
  NET_AD_REPLIED_CHAT: 'Net Ad Replied Chat'
}

export const SORT = {
  [`${SORT_FIELDS.PRICE}_${ORDER.ASC}`]: 'price_min',
  [`${SORT_FIELDS.PRICE}_${ORDER.DESC}`]: 'price_max',
  [`${SORT_FIELDS.KM}_${ORDER.ASC}`]: 'km_min',
  [`${SORT_FIELDS.KM}_${ORDER.DESC}`]: 'km_max',
  [`${SORT_FIELDS.YEAR}_${ORDER.DESC}`]: 'new_cars',
  [`${SORT_FIELDS.YEAR}_${ORDER.ASC}`]: 'older_cars',
  [`${SORT_FIELDS.FINANCED_PRICE}_${ORDER.DESC}`]: 'financed_price_max',
  [`${SORT_FIELDS.FINANCED_PRICE}_${ORDER.ASC}`]: 'financed_price_min',
  [`${SORT_FIELDS.RELEVANCE}_${ORDER.DESC}`]: 'new_ads',
  [`${SORT_FIELDS.RELEVANCE}_${ORDER.ASC}`]: 'older_ads'
}

export const SELLER_TYPES_TRANSLATIONS = {
  [SELLER_TYPE_PROFESSIONAL]: {[DEFAULT_CULTURE]: 'profesional'},
  [SELLER_TYPE_PRIVATE]: {[DEFAULT_CULTURE]: 'particular'}
}

export const TRACKING_FUEL_TYPES_FILTERS_TRANSLATIONS = {
  [FUEL_TYPE_GASOLINE_ID]: {[DEFAULT_CULTURE]: 'Gasolina'},
  [FUEL_TYPE_ELECTRIC_ID]: {[DEFAULT_CULTURE]: 'Eléctricas'}
}

export const BODY_TYPES_TRANSLATIONS = {
  [BODY_TYPE_ID_MOPED]: {[DEFAULT_CULTURE]: 'Ciclomotor'},
  [BODY_TYPE_ID_MOPED_2]: {[DEFAULT_CULTURE]: 'Ciclomotor'},
  [BODY_TYPE_ID_MOPED_GEARS]: {[DEFAULT_CULTURE]: 'Con marchas'},
  [BODY_TYPE_ID_SCOOTER_50]: {[DEFAULT_CULTURE]: 'Scooter 50cc'},
  [BODY_TYPE_ID_SCOOTER]: {[DEFAULT_CULTURE]: 'Scooter'},
  [BODY_TYPE_ID_SCOOTER_125]: {[DEFAULT_CULTURE]: 'cooter 125cc'},
  [BODY_TYPE_ID_SCOOTER_125PLUS]: {[DEFAULT_CULTURE]: 'Scooter +125cc'},
  [BODY_TYPE_ID_ROAD]: {[DEFAULT_CULTURE]: 'Carretera'},
  [BODY_TYPE_ID_ROAD_CUSTOM]: {[DEFAULT_CULTURE]: 'Custom'},
  [BODY_TYPE_ID_ROAD_NAKED]: {[DEFAULT_CULTURE]: 'Naked'},
  [BODY_TYPE_ID_ROAD_SPORT]: {[DEFAULT_CULTURE]: 'Sport'},
  [BODY_TYPE_ID_ROAD_SUPERMOTARD]: {[DEFAULT_CULTURE]: 'Supermotard'},
  [BODY_TYPE_ID_ROAD_TOURISM]: {[DEFAULT_CULTURE]: 'Turismo'},
  [BODY_TYPE_ID_OFFROAD]: {[DEFAULT_CULTURE]: 'Off-road'},
  [BODY_TYPE_ID_OFFROAD_CROSS]: {[DEFAULT_CULTURE]: 'Cross'},
  [BODY_TYPE_ID_OFFROAD_ENDURO]: {[DEFAULT_CULTURE]: 'Enduro'},
  [BODY_TYPE_ID_OFFROAD_KIDS]: {[DEFAULT_CULTURE]: 'Infantil'},
  [BODY_TYPE_ID_OFFROAD_TRAIL]: {[DEFAULT_CULTURE]: 'Trail'},
  [BODY_TYPE_ID_OFFROAD_TRIAL]: {[DEFAULT_CULTURE]: 'Trial'}
}

export const STOCK_TAB_NAME = {
  VEHICLES: 'vehicles',
  INFORMATION: 'information',
  RATINGS: 'ratings'
}

export const CATEGORY_ID_1_TO_PAGE_NAME_DICTIONARY = {
  [MOTOS_CATEGORY1_ID]: 'ads-list',
  [QUADS_CATEGORY1_ID]: 'ads-list-quads',
  [BUGGIES_CATEGORY1_ID]: 'ads-list-buggies',
  [MINIMOTOS_CATEGORY1_ID]: 'ads-list-minimotos',
  [CLASSICS_CATEGORY1_ID]: 'ads-list-classic-and-competition'
}

export const TRACKING_FILTERS_PAYMENT_TYPES_TRANSLATIONS = {
  CASH: 'contado',
  FINANCED: 'financiado',
  INSTALMENT: 'cuota mensual'
}

export const TRACKING_FILTERS_OFFER_TYPES_TRANSLATIONS = {
  [OFFER_TYPE_SECOND_HAND]: {[DEFAULT_CULTURE]: 'segunda-mano'},
  [OFFER_TYPE_NEW]: {[DEFAULT_CULTURE]: 'nuevo'}
}

export const SDRN_BASE = 'sdrn:motos.net:user:'

export const DEFAULT_CALL_TRACKING_SERVICE = CALL_TRACKING_SERVICES.DIALOGA

export const SESSION_TRACKING_IDENTIFIED_USER_KEY_PREFIX = 'tracking_identified_user_motos_'

export const REQUEST_STATUS_AI_SUCCESS = 'SUCCESS'

export const TRACKING_EVENT_AI_MAPPING = {
  GENERIC_ERROR: 'Generic error',
  NO_CONTENT_ERROR: 'Query correct but error in creating filters',
  GATEWAY_TIMEOUT_ERROR: 'Bedrock timeout',
  INTERNAL_SERVER_ERROR_ERROR: 'Server error',
  [REQUEST_STATUS_AI_SUCCESS]: 'success',
  UNAVAILABLE_FOR_LEGAL_REASONS_ERROR: 'Unethical query',
  UNPROCESSABLE_CONTENT_ERROR: 'Irrelevant query'
}

export const TRACKING_OS_NAME_ANDROID = 'Android'
export const TRACKING_OS_NAME_IOS = 'iOS'

export const TRACKING_OS_NAMES = {
  android: TRACKING_OS_NAME_ANDROID,
  ios: TRACKING_OS_NAME_IOS
}

export const TRACKING_HAS_PRICEDROP_TRUE = 'with_price_drop'
export const TRACKING_HAS_PRICEDROP_FALSE = 'without_price_drop'
